<h2 mat-dialog-title>Add Data</h2>
<mat-dialog-content>
  <div class="add-data-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <input id="uploadFile" type="file" class="d-none" multiple accept=".kml,.kmz,.zip,.csv,.wkt,.geojson" (change)="onFileInputChange($event)" />
    <div class="dropzone" [class.hidden]="isDragOver">
      <mat-icon>backup</mat-icon>
      <span>
        Drag files here or
        <span class="link-btn" (click)="selectFile()">browse</span>
      </span>
    </div>
    <div class="pulsating-circle" [class.hidden]="!isDragOver"></div>
    <div class="drag-over-text" [class.hidden]="!isDragOver">
      <mat-icon>backup</mat-icon>
      <span>Drop your files to upload</span>
    </div>
  </div>

  <div *ngIf="!isDragOver && pendingLayers.length === 0" class="mt-3">
    <div class="description mb-3">
      <div class="mat-font-title-sm mb-2">The following file types are supported. Each must be in WGS 84 (EPSG: 4326) and under 20 MB.</div>
      <span>1) A Shapefile formatted as a .zip file</span>
      <span>
        2) A CSV file.
        <a href="static/CSV_Template.csv" target="_blank">Download a CSV template here.</a>
      </span>
      <span>3) A .kml or .kmz file</span>
      <span>4) A .WKT file</span>
      <span>5) A .GeoJSON file</span>
    </div>
    <mat-divider></mat-divider>
    <mat-form-field class="mt-2" [floatLabel]="'always'">
      <mat-label class="mat-font-title-md">Import Data</mat-label>
      <mat-select [(value)]="urlType" (selectionChange)="onUrlTypeChange()">
        <mat-option *ngFor="let type of dataTypesArray" [value]="type.key">{{ type.description }}</mat-option>
      </mat-select>
    </mat-form-field>

    <form [formGroup]="form">
      <mat-form-field *ngIf="!isTextType" class="w-100" [floatLabel]="'always'">
        <mat-label class="mat-font-title-md" >URL</mat-label>
        <input matInput placeholder="URL" formControlName="url" />
        <mat-icon matSuffix *ngIf="form.controls.url.valid && form.controls.url.value" class="text-success">done</mat-icon>
        <mat-error *ngIf="form.controls.url.invalid && form.controls.url.touched">
          <ng-container *ngIf="form.controls.url.errors as errors">
            <div *ngIf="errors.required">URL is required.</div>
            <div *ngIf="errors.url">Invalid URL format.</div>
            <div *ngIf="errors.arcgis">URL must be an ArcGIS Feature Service endpoint (ends with /FeatureServer).</div>
          </ng-container>
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isTextType" class="w-100" >
        <textarea matInput rows="5" [placeholder]="'Paste ' + urlType + ' text'" formControlName="text"></textarea>
        <mat-icon matSuffix *ngIf="form.controls.text.valid" class="text-success">done</mat-icon>
        <mat-error *ngIf="form.controls.text.touched && form.controls.text.invalid">
          <ng-container *ngIf="form.controls.text.errors as errors">
            <div *ngIf="errors.required">{{ urlType }} text is required.</div>
            <div *ngIf="errors.invalidText">Invalid {{ urlType }} content.</div>
          </ng-container>
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Pending layers list -->
  <div *ngIf="pendingLayers.length > 0" class="pending-list mt-3">
    <div class="mat-font-title-sm">Your uploaded layers are being processed. Review, rename or remove them.</div>
    <mat-divider></mat-divider>
    <mat-list class="pending-scroll" role="list">
        @for ( layer of pendingLayers; track layer; let i = $index) {
            <app-add-layer-item
                    [layer]="layer"
                    [index]="i"
                    (onRemove)="showRemoveLayerDialog($event)"></app-add-layer-item>
            <mat-divider></mat-divider>
    }

    </mat-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!isDragOver" class="dialog-actions">
  <button matButton="elevated" (click)="cancelOrReset()">Cancel</button>
  <button
    *ngIf="pendingLayers.length === 0"
    matButton="filled" color="primary"
    (click)="proceedToNext()"
    [disabled]="!(form.controls.url.enabled && form.controls.url.valid) && !(form.controls.text.enabled && form.controls.text.valid)">
    Next
  </button>

  <button
    *ngIf="pendingLayers.length !== 0"
    matButton="filled" color="primary"
    (click)="addValidLayers()"
    [disabled]="!allPendingProcessed || !hasAnyValidFeature">
    Add Valid Layers
  </button>
</mat-dialog-actions>
